<template>
  <router-view />
</template>

<script>

export default {
  name: "ProjectInfo",
  components: {},
  props: {},
  data() {
    return {};
  },
  // 监听属性 类似于data概念
  computed: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {}
};
</script>

<style scoped lang="scss"></style>
